const EmptyValue = () => (
  <span className="inline-block text-xs text-slate-600">-</span>
);

export default EmptyValue;
